const getCurrentServer = () => 'https://cmintradevapi.cybermeru.com';

const getCurrentProject = () => 'CMIntraERPDev_BE';

const getMandEndPoint = () => 'rest';

const getCurrentFrontServer = () => 'https://cmintradev.cybermeru.com'

const getCurrentSocketServer = () => 'wss://cmintradevapi.cybermeru.com';

const getTemporaryResumeFileName = () => 'TemporaryResume.pdf';


export { getCurrentServer, getCurrentProject, getMandEndPoint, getCurrentFrontServer, getCurrentSocketServer, getTemporaryResumeFileName }